import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'
import { ITrainingType } from '../../interfaces'

const getSortTrainingTypesMutationRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/TrainingTypes/sort`,
})

const useSortTrainingTypesMutation = (options = {}) => {
  const request = useMemo(() => getSortTrainingTypesMutationRequest(), [])

  const sortTrainingTypes = useCallback(
    async (data: ITrainingType) => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingType, Error, ITrainingType>(sortTrainingTypes, options)

  return response
}

export default useSortTrainingTypesMutation